import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains21620uw5ew03f as contains,
  isEmpty2lvc2zgoeh0ds as isEmpty,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from './Range.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function isEmpty_0() {
  return !this.lessThanOrEquals_r7k2jg_k$(this.get_start_iypx6h_k$(), this.get_endInclusive_r07xpi_k$());
}
var ClosedFloatingPointRangeClass;
function ClosedFloatingPointRange() {
  if (ClosedFloatingPointRangeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClosedFloatingPointRange', VOID, VOID, [ClosedRange()]);
    ClosedFloatingPointRangeClass = $;
  }
  return ClosedFloatingPointRangeClass;
}
function rangeTo(_this__u8e3s4, that) {
  return new (ClosedFloatRange())(_this__u8e3s4, that);
}
function rangeTo_0(_this__u8e3s4, that) {
  return new (ComparableRange())(_this__u8e3s4, that);
}
function rangeTo_1(_this__u8e3s4, that) {
  return new (ClosedDoubleRange())(_this__u8e3s4, that);
}
function rangeUntil(_this__u8e3s4, that) {
  return new (OpenEndDoubleRange())(_this__u8e3s4, that);
}
function checkStepIsPositive(isPositive, step) {
  if (!isPositive)
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step must be positive, was: ' + toString(step) + '.');
}
var ClosedFloatRangeClass;
function ClosedFloatRange() {
  if (ClosedFloatRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this._start_1 = start;
        this._endInclusive_1 = endInclusive;
      }
      get_start_iypx6h_k$() {
        return this._start_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this._endInclusive_1;
      }
      lessThanOrEquals_wu9zzw_k$(a, b) {
        return a <= b;
      }
      lessThanOrEquals_r7k2jg_k$(a, b) {
        var tmp = typeof a === 'number' ? a : THROW_CCE();
        return this.lessThanOrEquals_wu9zzw_k$(tmp, typeof b === 'number' ? b : THROW_CCE());
      }
      contains_8bpbll_k$(value) {
        return value >= this._start_1 && value <= this._endInclusive_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_8bpbll_k$(typeof value === 'number' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return !(this._start_1 <= this._endInclusive_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof ClosedFloatRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this._start_1 === other._start_1 && this._endInclusive_1 === other._endInclusive_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, getNumberHashCode(this._start_1)) + getNumberHashCode(this._endInclusive_1) | 0;
      }
      toString() {
        return '' + this._start_1 + '..' + this._endInclusive_1;
      }
    }
    initMetadataForClass($, 'ClosedFloatRange', VOID, VOID, [ClosedFloatingPointRange()]);
    ClosedFloatRangeClass = $;
  }
  return ClosedFloatRangeClass;
}
var ComparableRangeClass;
function ComparableRange() {
  if (ComparableRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this.start_1 = start;
        this.endInclusive_1 = endInclusive;
      }
      get_start_iypx6h_k$() {
        return this.start_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.endInclusive_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof ComparableRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (equals(this.get_start_iypx6h_k$(), other.get_start_iypx6h_k$()) && equals(this.get_endInclusive_r07xpi_k$(), other.get_endInclusive_r07xpi_k$()));
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, hashCode(this.get_start_iypx6h_k$())) + hashCode(this.get_endInclusive_r07xpi_k$()) | 0;
      }
      toString() {
        return toString(this.get_start_iypx6h_k$()) + '..' + toString(this.get_endInclusive_r07xpi_k$());
      }
    }
    protoOf($).contains_3tkdvy_k$ = contains;
    protoOf($).isEmpty_y1axqb_k$ = isEmpty;
    initMetadataForClass($, 'ComparableRange', VOID, VOID, [ClosedRange()]);
    ComparableRangeClass = $;
  }
  return ComparableRangeClass;
}
var ClosedDoubleRangeClass;
function ClosedDoubleRange() {
  if (ClosedDoubleRangeClass === VOID) {
    class $ {
      constructor(start, endInclusive) {
        this._start_1 = start;
        this._endInclusive_1 = endInclusive;
      }
      get_start_iypx6h_k$() {
        return this._start_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this._endInclusive_1;
      }
      lessThanOrEquals_yc5mws_k$(a, b) {
        return a <= b;
      }
      lessThanOrEquals_r7k2jg_k$(a, b) {
        var tmp = typeof a === 'number' ? a : THROW_CCE();
        return this.lessThanOrEquals_yc5mws_k$(tmp, typeof b === 'number' ? b : THROW_CCE());
      }
      contains_p5zavb_k$(value) {
        return value >= this._start_1 && value <= this._endInclusive_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_p5zavb_k$(typeof value === 'number' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return !(this._start_1 <= this._endInclusive_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof ClosedDoubleRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this._start_1 === other._start_1 && this._endInclusive_1 === other._endInclusive_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, getNumberHashCode(this._start_1)) + getNumberHashCode(this._endInclusive_1) | 0;
      }
      toString() {
        return '' + this._start_1 + '..' + this._endInclusive_1;
      }
    }
    initMetadataForClass($, 'ClosedDoubleRange', VOID, VOID, [ClosedFloatingPointRange()]);
    ClosedDoubleRangeClass = $;
  }
  return ClosedDoubleRangeClass;
}
var OpenEndDoubleRangeClass;
function OpenEndDoubleRange() {
  if (OpenEndDoubleRangeClass === VOID) {
    class $ {
      constructor(start, endExclusive) {
        this._start_1 = start;
        this._endExclusive_1 = endExclusive;
      }
      get_start_iypx6h_k$() {
        return this._start_1;
      }
      get_endExclusive_pmwm6k_k$() {
        return this._endExclusive_1;
      }
      contains_p5zavb_k$(value) {
        return value >= this._start_1 && value < this._endExclusive_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_p5zavb_k$(typeof value === 'number' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return !(this._start_1 < this._endExclusive_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof OpenEndDoubleRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this._start_1 === other._start_1 && this._endExclusive_1 === other._endExclusive_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, getNumberHashCode(this._start_1)) + getNumberHashCode(this._endExclusive_1) | 0;
      }
      toString() {
        return '' + this._start_1 + '..<' + this._endExclusive_1;
      }
    }
    initMetadataForClass($, 'OpenEndDoubleRange', VOID, VOID, [OpenEndRange()]);
    OpenEndDoubleRangeClass = $;
  }
  return OpenEndDoubleRangeClass;
}
//region block: exports
export {
  ClosedFloatingPointRange as ClosedFloatingPointRange3bek8kkkwkj9x,
  checkStepIsPositive as checkStepIsPositive70940ky00dt4,
  rangeTo as rangeToeizvz34h11nd,
  rangeTo_1 as rangeTo5xinnemk0fd3,
  rangeTo_0 as rangeTo3js8ciqegc9cl,
  rangeUntil as rangeUntilvkeu8z37zujo,
};
//endregion

//# sourceMappingURL=Ranges.mjs.map
